<template>
    <div
        v-if="hasSession"
        class="flex h-full w-full items-center justify-center before:absolute before:bottom-1 before:left-1.5 before:right-1.5 before:block before:h-1 before:bg-primary-500"
    >
        {{ date.day }}
    </div>
    <div v-else>{{ date.day }}</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SelectRecurringProgramStartSessionFragmentFragment } from '~/resources/graphql/graphql'

const props = defineProps<{
    datesToSessions: Map<
        string,
        {
            data: SelectRecurringProgramStartSessionFragmentFragment
            bookingStatusAvailable: boolean
        }[]
    >
    date: {
        year: number
        month: number
        day: number
    }
}>()

const dateString = computed(() => {
    return (
        String(props.date.year).padStart(4, '0') +
        '-' +
        String(props.date.month + 1).padStart(2, '0') +
        '-' +
        String(props.date.day).padStart(2, '0')
    )
})

const hasSession = computed(() => {
    const sessions = props.datesToSessions.get(dateString.value)
    return sessions !== undefined && sessions.length > 0
})
</script>
